import React from "react";
import ArrowRight from "luna-react/icons/ArrowRight";
import { Link } from "redux-little-router";

export const Breadcrumbs = ({ items }) => {
  return (
    <div className="breadcrumb__wrapper">
      {items.map(({ text, link }, index) => (
        <div className="breadcrumb_item" key={index}>
          {link ? (
            <Link href={link} className="breadcrumb_text">
              {text}
            </Link>
          ) : (
            <span className="breadcrumb_text">{text}</span>
          )}
          <ArrowRight className="breadcrumb_arrow" />
        </div>
      ))}
    </div>
  );
};

export default Breadcrumbs;



// WEBPACK FOOTER //
// ./src/components/Breadcrumbs/Breadcrumbs.js